export const arrayRange = (length) => [...Array(length).keys()];
